var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-d36677ac": "",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg icon--xl",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 15.6125L11.8591 11.8591L15.6126 3.99998L19.366 11.8591L27.2251 15.6125L19.366 19.366L15.6126 27.2251L11.8591 19.366L4 15.6125Z",
    fill: "#002c5f",
    style: {
      translate: "none",
      rotate: "none",
      scale: "none",
      transformOrigin: "0px 0px",
      opacity: 1
    },
    "data-svg-origin": "15.612549781799316 15.612540245056152",
    transform: "matrix(0.714,0,0,0.714,0.98142,0.98142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.582 20.9208L32.4764 18.1057L35.2915 12.2114L38.1065 18.1057L44.0009 20.9208L38.1065 23.7359L35.2915 29.6302L32.4764 23.7359L26.582 20.9208Z",
    fill: "#002c5f",
    style: {
      translate: "none",
      rotate: "none",
      scale: "none",
      transformOrigin: "0px 0px",
      opacity: 1
    },
    "data-svg-origin": "35.29145050048828 20.92080020904541",
    transform: "matrix(0.947,0,0,0.947,-0.74239,-1.50402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3164 35.2906L22.2107 32.4755L25.0258 26.5812L27.8409 32.4755L33.7353 35.2906L27.8409 38.1057L25.0258 44L22.2107 38.1057L16.3164 35.2906Z",
    fill: "#002c5f",
    style: {
      translate: "none",
      rotate: "none",
      scale: "none",
      transformOrigin: "0px 0px",
      opacity: 1
    },
    "data-svg-origin": "25.02584934234619 35.29059982299805",
    transform: "matrix(0.9948,0,0,0.9948,-2.4827,-2.42931)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.5a51ada618346678e182fbbbdd15f023.svg";
export { ForwardRef as ReactComponent };